import React from "react";
import { withStyles } from "@material-ui/core/styles";
import StyledToolTip from "../../../StyledTooltip";
import {
  getDriverRouteSPHBPHCount,
  getFilteredLunchBreakDelaysByDriverRoute,
} from "../../../../utils/utils";

const styles = (theme) => ({
  root: {
    height: "100%",
    display: "flex",
    alignItems: "center",
  },
  popupContainer: {
    padding: "6px",
    backgroundColor: theme.ModalBGColor,
    minWidth: "120px",
  },
  value: {
    fontSize: theme.textFontSize,
    fontWeight: 600,
  },
  kpiDetails: {
    display: "flex",
    justifyContent: "space-between",
    padding: "6px 0",
  },
  title: {
    color: theme.KPI.KPILabel,
    letterSpacing: 0.4,
    marginRight: 2
  },
  driverName: {
    color: theme.tooltipText,
    width: "80%",
  },
});

const DriverNameToolTip = ({
  classes,
  data,
  context,
  terminalOffset,
}) => {
  let showStopKpi = false;
  const driverRoutes = context.getDriverRoutes(data.driverId);
  const kpiData = getDriverRouteSPHBPHCount({
    driverRoutes,
    /* When scheduled API get loaded before dispatch driver API, cell renderer props has reference to scheduled driver data */
    driverDispatchTime: driverRoutes[0]?.driverDispatchTime,
    terminalOffset,
    lunchBreakStops: getFilteredLunchBreakDelaysByDriverRoute(
      data.delays,
      driverRoutes.map((driver) => driver.routeId)
    ),
  });
  showStopKpi = kpiData.stopsPerHour > 0 || kpiData.billsPerHour > 0;
  
  if (!showStopKpi) {
    return data.driverName;
  }
  return (
    <div className={classes.popupContainer}>
      <div className={classes.kpiDetails}>
        <div className={classes.title}>Stops per hour:</div>
        <span className={classes.value}>{kpiData.stopsPerHour}</span>
      </div>
      <div className={classes.kpiDetails}>
        <div className={classes.title}>Bills per hour:</div>
        <span className={classes.value}>{kpiData.billsPerHour}</span>
      </div>
    </div>
  );
};

const DriverNameCell = (props) => {
  const { classes, data } = props;

  return (
    <div className={classes.root}>
      <StyledToolTip
        title={<DriverNameToolTip {...props} />}
      >
        <span className={classes.driverName}>{data.driverName}</span>
      </StyledToolTip>
    </div>
  );
};

export default withStyles(styles)(DriverNameCell);
